<template>
    <span>
        <icon-button
            class="w-5 h-5 m-auto cursor-pointer play-btn"
            :name="playBtnIcon"
            :iconBackground="iconBackground"
            :class="{
                'ar-player__play--active': isPlaying,
                'play-bg': iconBackground && !isPlaying,
                'pause-bg': iconBackground && isPlaying
            }"
            @click.native="playback"></icon-button>

        <audio :id="playerUniqId" :src="audioSource" class="hidden" preload="auto" controls=""></audio>
    </span>
</template>

<script>
import IconButton from './IconButton.vue';
import {convertTimeMMSS} from './lib/utils';

export default {
    props: {
        src: {type: String},
        record: {type: Object},
        filename: {type: String},
        iconBackground: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: 'play'
        }
    },
    data() {
        return {
            isPlaying: false,
            duration: convertTimeMMSS(0),
            playedTime: convertTimeMMSS(0),
            progress: 0
        };
    },
    components: {
        IconButton
    },
    mounted: function () {
        this.player = document.getElementById(this.playerUniqId);
        this.player.volume = 1.0;

        this.player.addEventListener('ended', () => {
            this.isPlaying = false;
        });

        this.player.addEventListener('loadeddata', (ev) => {
            this._resetProgress();
            this.duration = convertTimeMMSS(this.player.duration);
        });

        this.player.addEventListener('timeupdate', this._onTimeUpdate);
    },
    computed: {
        audioSource() {
            if (!this.url && !this.record) debugger;
            const url = this.src || this.record.url;
            if (url) {
                return url;
            } else {
                this._resetProgress();
            }
        },
        playBtnIcon() {
            if (this.name == 'playWhite') {
                return this.isPlaying ? 'pauseWhite' : 'playWhite';
            }

            return this.isPlaying ? 'pause' : 'play';
        },
        playerUniqId() {
            return `audio-player${this._uid}`;
        }
    },
    methods: {
        playback() {
            if (!this.audioSource) {
                return;
            }

            if (this.isPlaying) {
                this.player.pause();
            } else {
                setTimeout(() => {
                    this.player.play();
                }, 0);
            }

            this.isPlaying = !this.isPlaying;
        },
        _resetProgress() {
            if (this.isPlaying && this.player) {
                this.player.pause();
            }

            this.duration = convertTimeMMSS(0);
            this.playedTime = convertTimeMMSS(0);
            this.progress = 0;
            this.isPlaying = false;
        },
        _onTimeUpdate() {
            this.playedTime = convertTimeMMSS(this.player.currentTime);
            this.progress = (this.player.currentTime / this.player.duration) * 100;
        },
        _onUpdateProgress(pos) {
            if (pos) {
                this.player.currentTime = pos * this.player.duration;
            }
        }
    }
};
</script>


